// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__3e67M","header":"ClearentDisclaimer_header__3AA3-","inner":"ClearentDisclaimer_inner__2lLXU"};